import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';
import { roPlants } from '../../mock/mockData';

const ROPlant2000LPH = () => {
  const productData = roPlants.find(p => p.id === 'ro-2000');
  return <ProductPageTemplate productData={productData} />;
};

export default ROPlant2000LPH;